import { AxiosInstance } from 'axios';

import createAuthRefreshInterceptor from 'refresh';

import { safeLs } from 'shared/storages';

import { refreshKeycloakToken } from '../helpers';

import { KeycloakConfig, KeycloakTokens } from '../types';
import { KEYCLOAK_TOKENS } from '../constants';

export const setAxiosKeyCloakAuthInterceptor = (
  axiosInstance: AxiosInstance,
  keycloakConfig?: KeycloakConfig,
) => {
  axiosInstance.interceptors.request.use(config => {
    const keycloakTokens = safeLs.get<KeycloakTokens, 'sync'>(KEYCLOAK_TOKENS, {
      parse: true,
      type: 'sync',
    });
    const token = keycloakTokens?.token;
    if (config.headers && token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });

  const { refreshToken } = refreshKeycloakToken(keycloakConfig);

  createAuthRefreshInterceptor(axiosInstance, refreshToken, {
    statusCodes: [401],
  });
};
